import { render, staticRenderFns } from "./notFound.vue?vue&type=template&id=ada26ab0&"
var script = {}
import style0 from "./notFound.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports